import React, { useState, useEffect } from "react";
import {
  Grid,
  LinearProgress,
  Select,
  OutlinedInput,
  MenuItem,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";

import { useHistory } from "react-router-dom";

// styles
import useStyles from "./styles";

// components
// import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { Typography } from "../../components/Wrappers/Wrappers";

//firebase
import { db } from "../../context/firebase";
import { getDocs, collection } from "firebase/firestore";

export default function StudentDashboard(props) {
  var classes = useStyles();
  var theme = useTheme();

  const navigate = useHistory();

  const handlevideopage = (url, poster, title) => {
    try {
      navigate.push({
        pathname: "/student/videoplayer",
        params: { url: url, poster: poster, title: title },
      });
    } catch (err) {
      alert(err.message);
    }
  };

  const [list, setList] = useState([]);

  var store = [];

  const fetchList = async () => {
    const querySnapshot = await getDocs(
      collection(
        db,
        "specialChapter",
        "Class XII Class Backup",
        "Class XII Class Backup"
      )
    );
    querySnapshot.forEach((doc) => {
      store.push({
        name: doc.data().name,
        image: doc.data().image,
        video: doc.data().video,
        desc: doc.data().description,
      });
      // console.log(doc.data());
      // console.log(`${doc.id} => ${doc.data()}`);
    });
    setList(store);
  };

  useEffect(() => {
    fetchList();
  }, []);

  return (
    <>
      <Grid container spacing={6}>
        {list.map((value) => (
          <Grid item xs={12} md={4} lg={3} sm={12} spacing={4} onClick={() => handlevideopage(value.video, value.image, value.name)}>
            <Card className={classes.card}>
              <CardActionArea>
                <CardMedia
                  className={classes.media}
                  image={value.image}
                  title="Class 11"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    {value.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    {value.desc}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
